import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import SvnLogo from "@/components/SvnLogo";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/shows", label: "Shows" },
  { to: "/episodes", label: "Episodes" },
  { to: "/espanol", label: "Español" },
  { to: "/sponsors", label: "Sponsors" },
  { to: "/membership", label: "Membership" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl border-b border-white/10"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="nav-home-logo" onClick={() => setOpen(false)}>
          <SvnLogo size="sm" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-xs font-bold uppercase tracking-[0.2em] transition-colors ${
                  isActive ? "text-white" : "text-neutral-400 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/membership"
            data-testid="nav-join-svn-plus"
            className="text-xs font-black uppercase tracking-widest bg-gold text-black px-5 py-2.5 hover:shadow-[0_0_20px_rgba(212,175,55,0.5)] transition-all"
          >
            Join SVN+
          </Link>
        </div>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          data-testid="nav-mobile-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/95" data-testid="nav-mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-4">
            {LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={`text-sm font-bold uppercase tracking-widest ${
                  loc.pathname === l.to ? "text-white" : "text-neutral-400"
                }`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/membership"
              onClick={() => setOpen(false)}
              className="mt-2 text-center text-xs font-black uppercase tracking-widest bg-gold text-black px-5 py-3"
              data-testid="nav-mobile-join-svn-plus"
            >
              Join SVN+
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
